import React from 'react';
import ContentLoader from 'react-content-loader';

import Responsive from '@/components/Responsive';

const WebLoader = (props: any) => (
  <ContentLoader
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    height={1192}
    speed={2}
    viewBox="0 0 1440 1192"
    width="100%"
    {...props}>
    <rect height="600" rx="8" ry="8" width="1440" x="0" y="0" />
    <rect height="24" rx="4" ry="4" width="491" x="445" y="458" />
    <rect height="24" rx="4" ry="4" width="491" x="445" y="500" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="646" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="678" />
    <rect height="14" rx="4" ry="4" width="435" x="398" y="710" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="787" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="819" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="851" />
    <rect height="14" rx="4" ry="4" width="642" x="398" y="883" />
    <rect height="200" rx="12" ry="12" width="642" x="398" y="992" />
  </ContentLoader>
);

const MobileLoader = (props: any) => (
  <ContentLoader
    backgroundColor="#d7d6d6"
    foregroundColor="#ecebeb"
    height={679}
    speed={2}
    viewBox="0 0 414 679"
    width="100%"
    {...props}>
    <path d="M 0 0 h 414 v 396 H 0 z" />
    <rect height="24" rx="4" ry="4" width="284" x="30" y="249" />
    <rect height="24" rx="4" ry="4" width="284" x="30" y="291" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="443" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="475" />
    <rect height="14" rx="4" ry="4" width="256" x="18" y="507" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="569" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="601" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="633" />
    <rect height="14" rx="4" ry="4" width="378" x="18" y="665" />
  </ContentLoader>
);

const Loader: React.FC<any> = (props) => {
  return (
    <Responsive>
      <Responsive.Default>
        <WebLoader {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <MobileLoader {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default Loader;
